
const DiagramData = [
    {
        titlePopUp: 'ראש הרשות',
        titleDisplayMobile: (
            <>
                ראש הרשות
            </>
        ),
        titleDisplayDesktop: (
            <>
                ראש הרשות
            </>
        ),
        content: (
            <>
                <b>תפקיד הראש רשות בחירום: אחראי לתפקוד הרשות בשגרה ובחירום.</b>
                <ul>
                    <li>
                        מינוי בעלי התפקידים בחירום, וידוא הכשרתם ומוכנותם לחירום;
                    </li>
                    <li>
                        הקצאת משאבים למוכנות לחירום, הכנת המרה"פ, אישור נוהלי העבודה ווידוא מוכנות הצוותים לחירום;
                    </li>
                    <li>
                        איוש והפעלת ועדת המל"ח המקומית וועדות המשנה ברגיעה ובחירום;
                    </li>
                    <li>
                        קביעת שגרת הפעילות ברשות במצבי החירום השונים, בתיאום עם גורמי החירום האחראים לפי חוק, לרבות רמת הפעלת השירותים לאוכלוסייה, פתיחת המרה"פ ונוהלי הפעלתו;
                    </li>
                    <li>
                        כינוס ועדת מל"ח מקומית וניהול עבודתה (משמש כיו"ר הוועדה)
                    </li>
                    <li>
                        וידוא תפקוד הרשות להמשך מתן שירותים חיונים לאוכלוסייה בכלל תרחישי החירום.
                    </li>
                </ul>
            </>
        ),
        classNameDiv: 'first-frame',
        classNameTitle: 'first-frame-text'
    },
    {
        titlePopUp: 'מנכ"ל / רמ"ט',
        titleDisplayMobile: (
            <>
                מנכ"ל / רמ"ט
            </>
        ),
        titleDisplayDesktop: (
            <>
                מנכ"ל / רמ"ט
            </>
        ),
        content: (
            <>
                <b> תפקיד המנכ"ל בחירום - ראש המטה (רמ"ט) </b>
                <ul>
                    <li>
                        המנכ"ל בחירום ישמש כרמ"ט הרשות, ינהל ויתאם בחירום את כל גורמי הרשות לביצוע החלטות ראש הרשות וישמש כממלא מקום ראש הרשות בהיעדרו.
                    </li>
                    <li>
                        ניהול עבודת השולחן המרכזי;
                    </li>
                    <li>
                        ניהול שוטף של מרכז ההפעלה הרשותי;
                    </li>
                    <li>
                        תיאום בין המכלולים השונים במטה החירום והכוונתם בביצוע משימותיהם ובתגובה לאירועים;
                    </li>
                    <li>
                        תיאום עם גופי החירום הפועלים במרחב הרשותי – היקל"ר, נפת פיקוד העורף, המשטרה, כב"ה ומד"א, משרדי ממשלה, רשויות ייעודיות, גופים ומפעלים חיוניים;
                    </li>
                    <li>
                        ניהול תמונת מצב שוטפת של הרשות ויצירת תמונת מצב בעת אירוע, כולל המשאבים העיקריים הזמינים של הרשות;
                    </li>
                    <li>
                        העברת תמונת המצב לנפת פיקוד העורף;
                    </li>
                    <li>
                        לאור הערכת המצב – וידוא העברת דרישות הרשות לפיקוד העורף, משטרת ישראל, משרדי ממשלה, רשויות וגופים ייעודיים;
                    </li>
                    <li>
                        הפעלה החפ"ק הרשותי בעת אירוע ושיגור צוותים ייעודיים לפי הצורך;
                    </li>
                    <li>
                        הפעלת מטה החירום הרשותי בהתאם לשעון הפעילות הרשותי בחירום, קביעת סדרי עבודה, רמת הכוננות והאיוש של מכלולי מטה החירום
                    </li>
                    <li>
                        תיאום הפעילות מול אגף הביטחון והחירום ברשות המקומית;
                    </li>
                    <li>
                        ריכוז הטיפול בבקשות צה"ל ומשטרת ישראל לסיוע.
                    </li>
                </ul>
            </>
        ),
        classNameDiv: 'second-frame',
        classNameTitle: 'second-frame-text'
    },
    {
        titlePopUp: 'מכלול מבצעים',
        titleDisplayMobile: (
            <>
                <span style={{ fontSize: '10vmin' }}>מכלול</span><br />  מבצעים
            </>
        ),
        titleDisplayDesktop: (
            <>
                <span style={{ fontSize: '5vmin' }}>מכלול</span><br />  מבצעים
            </>
        ),
        content: (
            <>
                <b>תפקיד המכלול: ניהול עבודת המטה של הרשות המקומית בחירום</b>
                <ul>
                    <li>הפעלה של מרכז ההפעלה ומערכי השליטה, הדיווח והבקרה;
                    </li>
                    <li>ריכוז התמ"ץ הרשותי מכלל המכלולים לכדי תמונת מצב אחידה;
                    </li>
                    <li>ביצוע בקרה ומעקב אחר הנחיות ראש הרשות ומנהל הלחימה במרכז ההפעלה;
                    </li>
                    <li>הפעלת הכוחות המבצעיים ברשות בהתאם לצורך;</li>
                    <li>וידוא פעילות הרשות בהתאם לשעון הפעילות הרשותי בחירום;
                    </li>
                    <li>הפעלת חפ"ק רשותי במקרה הצורך, או השתלבות בחפ"ק אחוד של מנהל האירוע בשטח;
                    </li>
                    <li>הפעלת מערכי החירום לפי תפיסת ההפעלה ובכפוף להחלטת ראש הרשות;
                    </li>
                    <li>תיאום אופרטיבי של הרשות מול גורמי החירום והביטחון ומתן מענה בחירום;
                    </li>
                </ul>
                <br />
                <b>תאים במסגרת המכלול:
                </b>
                <br />
                - תא חירום וביטחון
                <br />
                - תא שליטה ודיווח
                <br />
                - תא ניהול שולחן מרכזי
            </>
        ),
        classNameDiv: 'blue-frame blue-box',
        classNameTitle: 'colored-box-text'
    },
    {
        titlePopUp: 'יקל"ר',
        titleDisplayMobile: (
            <>
                יקל"ר
            </>
        ),
        titleDisplayDesktop: (
            <>
                יקל"ר
            </>
        ),
        content: (
            <>
                <b>תפקיד היקל"ר בחירום : קישור בין הרשות לפקע"ר.
                </b>
                <ul>
                    <li>
                        להוות גורם מתאם ומקשר בין הפיקוד והשליטה (פו"ש) הצבאי (פקמ"ר-נפה) למערך הניהול והשליטה הרשותי, באמצעות: סיוע בהערכת מצב וסנכרון פנים רשותי, שיקוף יכולת ההתמודדות, העברת צרכים ופערים בעת חירום.
                    </li>
                    <li>
                        העברה והסברה של המידע וההנחיות של פיקוד העורף והפיקוד המרחבי לגורמי הרשות המקומית, בדגש על העוסקים במתן מידע לציבור ובדגש למדיניות ההתגוננות.
                    </li>
                    <li>
                        השתתפות בגיבוש תמונת מצב והערכת המצב הרשותית.
                    </li>
                    <li>
                        תיאום הרשות המקומית והדרכתה בתחום ההתגוננות האזרחית, בהתאם להנחיית הנפה, המחוז והפיקוד.
                    </li>
                    <li>
                        ריכוז המידע על אודות הפעולות המתבצעות במטה החירום הרשותי בזמן אירוע והעברתו לנפה.
                    </li>
                    <li>
                        קישור בין הרשות לבין הנפה לתיאום ביניהן בכלל, ובתחום הסיוע ההדדי בפרט, בנושאי אמצעים, תשתיות וכוח אדם.
                    </li>
                    <li>
                        עדכון הרשות המקומית במצב (סטטוס) הטיפול באירוע על ידי הנפה.
                    </li>
                    <li>
                        סיוע במיצוי הגורמים במרחב האזרחי לרשות המקומית (מגזר שני, שלישי, קהילות) על מנת לתמוך את הרציפות התפקודית ברשות.
                    </li>
                </ul>
            </>
        ),
        classNameDiv: 'orange-box',
        classNameTitle: 'colored-box-text'
    },
    {
        titlePopUp: 'ארגוני החירום',
        titleDisplayMobile: (
            <>
                ארגוני החירום
            </>
        ),
        titleDisplayDesktop: (
            <>
                ארגוני החירום
            </>
        ),
        content: (
            <>
                ארגוני החירום פועלים בתיאום עם הרשויות המקומיות לשם שמירה על רציפות תפקודית, הצלת חיים ומתן מענה ראשוני לצרכים של האוכלוסייה. תפקידם המרכזי הוא להפעיל את היכולות המבצעיות והמומחיות שברשותם, כמו פינוי, כיבוי, חילוץ, אבטחה ומתן טיפול רפואי, תוך שיתוף פעולה הדוק עם הרשות המקומית וחמ״ל הרשותי.
                <br /><br />
                שיתוף הפעולה כולל תיאום מידע, תכנון משותף, הצבת כוחות ומשאבים בהתאם לצרכים בשטח ועוד.
                <br /><br />
                האחריות של ארגוני החירום היא מקצועית ומבצעית - הם אחראים לביצוע הפעולות הייעודיות שלהם בהתאם לסוג האירוע, אך גם לתמיכה בפיקוד ובשליטה של הרשות המקומית.            </>
        ),
        classNameDiv: 'red-box',
        classNameTitle: 'colored-box-text'
    },
    {

        titlePopUp: 'מכלול אוכלוסייה',
        titleDisplayMobile: (
            <>
                <span style={{ fontSize: '8vmin' }}>מכלול</span><br /> אוכלוסייה
            </>
        ),
        titleDisplayDesktop: (
            <>
                <span style={{ fontSize: '5vmin' }}>מכלול</span><br /> אוכלוסייה
            </>
        ),
        content: (
            <>
                <b>תפקיד המכלול: מתן מענה לתושבי הרשות ע"פ יעדי השירות בתחומים: רווחה, בריאות, פס"ח ודת
                </b>
                <ul>
                    <li>גיבוש תמונת מצב והערכת מצב האוכלוסייה ברשות, חיזוי התנהגותה וצרכיה וגיבוש תוכניות פעולה בהתאם;
                    </li>
                    <li>
                        העברת נתונים על האוכלוסייה באזור האירוע ומסירתם לגוף החירום המנהל את האירוע (צה"ל-פיקוד העורף או משטרת ישראל)
                    </li>
                    <li>
                        איתור ואבחון קבוצות אוכלוסייה הנזקקות לסיוע לאור המצב ומתן המענה הנדרש בתיאום עם מטה החירום הרשותי;
                    </li>
                    <li>
                        תיאום עם הגורמים המקצועיים החיצוניים לרשות בכל הקשור למתן שירותים לאוכלוסייה, כגון קופות החולים, משרד הבריאות הנפתית/מחוזית, משרד הרווחה, משרד עלייה וקליטה, מועצות דתיות, חברות קבורה, המוסד לביטוח לאומי, משרד הבריאות, קצין ההתנהגות ביקל"ר;
                    </li>
                    <li>זימון וריכוז פעילות הוועדה לפס"ח;
                    </li>
                    <li>זימון וריכוז פעילות הוועדה להתנדבות;
                    </li>
                    <li>ניהול מתקני הקליטה של מפונים חסרי קורת גג - בהתייעצות עם ועדת פס"ח;
                    </li>
                    <li>פתיחת תחנת ריכוז חללים מקומית/מרחבית לפי הנחיית רשות פס"ח;
                    </li>
                    <li>מתן מענה לצורכי התושבים באמצעות מערך המתנדבים ומערכים קהילתיים
                    </li>
                </ul>
                <br />
                <b>תאים במסגרת המכלול:
                </b>    <br />
                - תא רווחה
                <br />
                - תא בריאות
                <br />
                - תא פס"ח 
                <br />
                - תא דת
                <br />
                - תא קליטת עליה
                
            </>
        ),
        classNameDiv: 'colored-box-sub',
        classNameTitle: 'colored-box-text'
    },
    {
        titlePopUp: 'מכלול החינוך',
        titleDisplayMobile: (
            <>
                <span style={{ fontSize: '8vmin' }}>מכלול</span><br /> החינוך            </>
        ),
        titleDisplayDesktop: (
            <>
                <span style={{ fontSize: '5vmin' }}>מכלול</span><br /> החינוך
            </>
        ),
        content: (
            <>
                <b>תפקיד המכלול: מתן מענה לתושבי הרשות ע"פ יעדי השירות בתחומי החינוך וקביעת מתכונת הפעלת מסגרות החינוך הפורמלי והבלתי פורמלי ע"פ ההנחיות
                </b>
                <ul>
                    <li>הפעלת מערכת החינוך הרשותית בהתאם להחלטות ראש הרשות ומטה החירום הרשותי והנחיות פיקוד העורף
                    </li>
                    <li>להעלות צרכים ודרישות למחוז משרד החינוך בסיוע המפקח המתכלל הרשותי
                    </li>
                    <li>לסייע למכלול אוכלוסייה בקליטת אוכלוסייה מפונה במוסדות חינוך המשמשים כמתקני קליטה - על-פי נוהל 24 של פס"ח ונוהל 13 ב"חוזר מנכ"ל משרד החינוך לשעת-חירום"
                    </li>
                    <li>לשלב את מוסדות הקהילה, מתנ''ס ומנו''ס (מנהל נוער וספורט) במענים ובפתרונות לצורכי מערכת החינוך
                    </li>
                    <li>להפעיל את מערך ההסעות לתלמידים בהתאם לפעילות מוסדות החינוך ובתיאום עם מכלול לוגיסטיקה
                    </li>
                    <li>להפעיל תכניות חירום בתחומים הבאים: תכנית למידה בחירום, תוכנית למידה מרחוק, תוכניות הפגה, הפעלת בני נוער מתנדבים, תמיכה נפשית ועוד</li>
                </ul>
                <br />
                <b> תאים במסגרת המכלול:
                </b>
                <br />
                - תא חינוך פורמאלי
                <br />
                - תא חינוך בלתי פורמאלי
            </>
        ),
        classNameDiv: 'colored-box-sub',
        classNameTitle: 'colored-box-text'
    },
    {
        titlePopUp: 'מכלול מידע לציבור',
        titleDisplayMobile: (
            <>
                <span style={{ fontSize: '8vmin' }}>מכלול</span><br /> מידע לציבור
            </>
        ),
        titleDisplayDesktop: (
            <>
                <span style={{ fontSize: '5vmin' }}>מכלול</span><br /> מידע לציבור
            </>
        ),
        content: (
            <>
                <b>
                    תפקיד המכלול: מתן מענה לתושבי הרשות ע"פ יעדי השירות בתחום המידע לציבור תוך שימוש באמצעי מדיה שונים, הפעלת המוקד העירוני והפצת המסרים וההנחיות לציבור
                </b>
                <ul>
                    <li>מתן מענה לפניות התושבים במידע השוטף הקשור לשירותים המוניציפאליים
                    </li>
                    <li>הכנת תכניות לימודים למלחמה בהתאם לתפוסת המקלטים והמרחבים המוגנים במוסדות החינוך והכנת תכניות עבור מוסדות חינוך חסרי מיגון לקיום לימודים במוסדות חליפיים ממוגנים, בהתאמה למדרגי מדיניות ההתגוננות (בהכרזת "מצב מיוחד בעורף")
                    </li>
                    <li>ספק מידע על השינויים באספקת שירותים חיוניים לאוכלוסייה הניתנים על-ידי רשויות ממלכתיות (בריאות, חינוך, תחבורה, דלק וכדומה)
                    </li>
                    <li>יסוף נתונים, עיבודם וגיבוש תמונת מצב המתבססת על המידע המתקבל ביחידת דוברות, מוקד, ובשירותים הדיגיטאליים. והעברתה לגורמים רלוונטיים ברשות על-פי תזמון שנקבע מראש
                    </li>
                    <li>כתיבת תכנית הסברה רשותית הנגזרת מתמונת המצב שגובשה וכוללת: מסרים ומידע נדרש ואופן הפצתם באמצעים הקיימים ברשות
                    </li>
                    <li>ביצוע פעולות הסברה והפצת מידע לקבוצות אוכלוסייה עם צרכים מיוחדים ולמגזרים השונים, בתיאום עם המכלולים האחרים ובדגש על מכלול הטיפול באוכלוסייה
                    </li>
                    <li>ייזום פרסומים והודעות לאמצעי התקשורת, וסיקור עיתונאי של האירועים
                    </li>
                    <li>ייזום מסרים תומכים לאוכלוסייה על רקע תמונת המצב המשתקפת ברשות
                    </li>
                    <li>תאום מסרים עם כלל גורמי החירום הרלוונטיים: פיקוד העורף, מידע לציבור ברח"ל, מרכזי מידע בבתי חולים וארגוני החירום: מד"א,כב"ה, מ"י
                    </li>
                    <li>לצפות ולהאזין לפרסומים בתקשורת באופן רצוף על מנת להכיר ולדעת את המידע המפורסם שיכול להיות בסיס לפניות רבות של הציבור
                    </li>
                </ul>
                <br />
                <b> תאים במסגרת המכלול:
                </b>
                <br />
                -  תא שירותים דיגיטליים
                <br />
                - תא מוקד רשותי
                <br />
                - תא דוברות
            </>
        ),
        classNameDiv: 'colored-box-sub',
        classNameTitle: 'colored-box-text'
    },
    {
        titlePopUp: 'מכלול הנדסה ותשתיות',
        titleDisplayMobile: (
            <>
                <span style={{ fontSize: '8vmin' }}>מכלול</span><br /> הנדסה ותשתיות            </>
        ),
        titleDisplayDesktop: (
            <>
                <span style={{ fontSize: '5vmin' }}>מכלול</span><br /> הנדסה ותשתיות            </>
        ),
        content: (
            <>
                <b>תפקיד המכלול: מתן מענה לתושבי הרשות ע"פ יעדי השירות בתחומי הנדסה, חשמל, מים וביוב, דרכים והגנת הסביבה
                </b>
                <ul>
                    <li>הערכת נזקים במבנים ובתשתיות לאחר אירוע באמצעות מהנדסים ואדריכלים המוכשרים לכך וגיבוש המלצה הנדסית על מבנים שנפגעו באשר לאפשרות החזרת האוכלוסייה להתגורר בהם והמשך הטיפול
                    </li>
                    <li>המשך מתן שירותים מוניציפליים חיוניים לאוכלוסייה בתחומי מים, ביוב, דרכים, ניקוז ובינוי
                    </li>
                    <li>הפעלת "צוותי שטח הנדסה ותשתיות" של הרשות
                    </li>
                    <li>הפעלת תכנית גיבוי לאספקת מים חלופיים בתחנות חלוקה. באזורים השונים של הרשות והפעלתה באזור שנפגע
                    </li>
                    <li>הפעלת גנרטורים כגיבוי לאספקת חשמל, לאתרי קליטה ולמתקנים נוספים שבאחריות הרשות ולסיוע במוקדי האירוע</li>
                    <li>תיאום תיקון מהיר של דרכים, של מבנים ושל תשתיות חיוניות על ידי צוותי השטח או על ידי קבלנים להבטחת צירים פנויים וכדי לאפשר את החזרת שגרת החיים מהר ככל הניתן
                    </li>
                    <li>עדכון מכלול המידע לציבור במידע הנחוץ לציבור בתחומי עיסוק המכלול, כגון: מיקום פריסת מכלי מים ניידים, תיקון מבנים וצירים חסומים ופנויים ועוד
                    </li>
                    <li>קיום יחסי גומלין עם מחזיקי חומ"ס במרחב הרשות
                    </li>
                    <li>מיפוי וטיפול במפגעים סביבתיים (בתאום עם מחוז הגנ"ס), כגון: אויר, אסבסט, זיהום חופים, קרינה, סביבה חקלאית, שפכים וקרקעות מזוהמות (פסולת ומזיקים מטופלים במכלול לוגיסטיקה)
                    </li>
                </ul>
                <br />
                <b>תאים במסגרת המכלול:
                </b>
                <br />
                - תא תא הנדסה ובינוי
                <br />
                - תא חשמל
                <br />
                - תא מים וביוב
                <br />
                - תא דרכים וניקוז
                <br />
                - תא הגנ"ס

            </>
        ),
        classNameDiv: 'colored-box-sub',
        classNameTitle: 'colored-box-text'
    },
    {
        titlePopUp: 'מכלול לוגיסטיקה ותפעול',
        titleDisplayMobile: (
            <>
                <span style={{ fontSize: '8vmin' }}>מכלול</span><br /> לוגיסטיקה ותפעול
            </>
        ),
        titleDisplayDesktop: (
            <>
                <span style={{ fontSize: '5vmin' }}>מכלול</span><br /> לוגיסטיקה ותפעול
            </>
        ),
        content: (
            <>
                <b>תפקיד המכלול: מתן מענה לוגיסטי, בהתאם לרמות השירות שנקבעו לחירום, בתחומי השירותים הלוגיסטיים והשירותים החיוניים הקשורים ב: מזון, דלק, גפ"ם, תובלה, צמ"ה, היסעים, פיקוח, משכ"ל, מחסנים.
                </b>
                <ul>
                    <li>תמיכה לוגיסטית בכוחות העירייה הפועלים בחירום, ניהול השירותים הלוגיסטיים והתפעוליים של העיר (כגון מזון לעובדים, דלק, רכב, צמ"ה, היסעים, תובלה יבשתית, גנרטורים), לרבות בעת אירוע;
                    </li>
                    <li>ניהול מחסני החירום (ציוד למתקני קליטה, אמצעֵי תאורת חירום, גנרטורים) ומלאי החירום של הרשות בדלק וגפ"ם, ציוד וחלפים הדרושים לפעילות בעיר;</li>
                    <li>תפעול מערך ההיסעים של העירייה, לרבות ביצוע ההסעות של מערכת החינוך בהתאם לתוכנית, בכפוף למדיניות החירום, ביצוע הסעות לעובדי העירייה לאיוש המשמרות ברציפות וסיוע לפעילות שבאחריות העירייה;
                    </li>
                    <li>שינוע ציוד ממחסני החירום העירוניים (לרבות ממחסני פס"ח העירוניים והמחוזיים);
                    </li>
                    <li>מסירת מידע לאוכלוסייה, באמצעות מכלול המידע לציבור על מערך שירותים חיוניים, כגון: מרכולים, תחבורה ציבורית, דלק וגפ"ם, בנקאות, דואר, משרדי ממשלה ובנקים הפתוחים בחירום, שיאפשרו ניהול שגרת חירום;
                    </li>
                    <li>מתן שירותי תברואה לאוכלוסייה ולעסקים;
                    </li>
                </ul>
                <br />
                <b>תאים במסגרת המכלול:
                </b>
                <br />
                - תא תחבורה
                <br />
                - תא מזון ומשכ"ל
                <br />
                - תא גיבוי אנרגטי
                <br />
                - תא הרכש האספקה
                <br />
                - תא התברואה

            </>
        ),
        classNameDiv: 'colored-box-sub',
        classNameTitle: 'colored-box-text'
    },
    {
        titlePopUp: 'מכלול משא"ן ומנהל כללי',
        titleDisplayMobile: (
            <>
                <span style={{ fontSize: '8vmin' }}>מכלול</span><br /> משא"ן ומנהל כללי
            </>
        ),
        titleDisplayDesktop: (
            <>
                <span style={{ fontSize: '5vmin' }}>מכלול</span><br /> משא"ן ומנהל כללי
            </>
        ),
        content: (
            <>
                <b>תפקיד המכלול: מתן מענה כללי בהתאם לרמות השירות שנקבעו לחירום בהיבטים: כוח האדם, התיירים, התקשוב.</b>
                <ul>
                    <li>גיבוש תמ"ץ בנושא כוח אדם, תיירות ותקשוב ברשות המקומית
                    </li>
                    <li>השלמות איוש או תגבור כוח האדם בגופי הרשות בהתאם לצורכי החירום, על-ידי השמת עובדים מרותקים משקיים - ויסוח העובדים המרותקים לחירום</li>
                    <li>מתן שירותי תברואה והגנת הסביבה לאוכלוסייה ולעסקים
                    </li>
                    <li>טיפול בתיירים בהתאם למדיניות הממשלה
                    </li>
                    <li>מתן מענה תקשובי לרשות ווידוא אבטחת מערכות המידע כנגד איומי הסייבר</li>
                </ul>
                <br />
                <b>תאים במסגרת המכלול:
                </b>
                <br />
                - תא כוח אדם
                <br />
                - תא מחשוב וסייבר
                <br />
                - תא תיירות
            </>
        ),
        classNameDiv: 'colored-box-sub',
        classNameTitle: 'colored-box-text'
    },
];


export default DiagramData;